module.exports = __webpack_public_path__ + "img/piano_orario2.3b5519ff.png";